import React, { Fragment, useMemo } from 'react';
import { useState } from 'react';
import { useAuthConfig } from "../../shared/utils";
import { DatePicker, Button } from "@deere/ux.uxframe-react";
import Moment from 'moment';
import { Col, Breadcrumb, Form, Card, Alert, Title } from '@deere/ux.uxframe-react';
import { TableContainerRequestView } from './SearchTable';
import { ERROR_MESSAGE } from '../../shared/Constants';
import { Loading } from '../../shared/Loading';

export default function Search() {
    const [alertVisible, setAlertVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [alertVariant, setAlertVariant] = useState('');
    const [onClickSearch, setOnClickSearch] = useState(false);
    const [flagForCount, getflagForCount] = useState(false);
   
    var startdate1 = Moment('20071015').format("YYYY-MM-DD");
    const [searchBy, setSearchBy] = useState("");
    const [material, setMaterial] = useState("");
    const [status, setStatus] = useState("");
    const [fromDate, setFromDate] = useState(startdate1);
    const [toDate, setToDate] = useState("");
    const [manager, setManager] = useState("");
    const [processor, setProcessor] = useState("");
    const [requestor, setRequestor] = useState("");
    const [submitButton, setSubmitButton] = useState(false);
    
    let authAxios = useAuthConfig();

    const headers = {
        "content-type": "application/json",
        "accept": "*/*"
    }



    const [result, setResult] = useState([]);

    const handlerequestorChange = (event) => {
        setRequestor(event.target.value);
    }

    const handlematerialChange = (event) => {
        setMaterial(event.target.value);
    }


    const handlestatusChange = (event) => {
        setStatus(event.target.value);
    }

    const handleprocessorChange = (event) => {
        setProcessor(event.target.value);
    }

    const handlemanagerChange = (event) => {
        setManager(event.target.value);
    }

    const handlefromDateChange = (event) => {

        setFromDate(Moment(event.target.value).format('YYYY-MM-DD'));
    }

    const handletoDateChange = (event) => {

        setToDate(Moment(event.target.value).format('YYYY-MM-DD'));


    }

    const handleSearchByChange = (event) => {


        setMaterial("");
        setStatus("");
        if (event.target.value === "dateRange") {
            setFromDate(startdate1);
        } else {
            setFromDate(null);
        }
        setToDate(null);
        setProcessor("");
        setManager("");
        setRequestor("");
        setSearchBy(event.target.value);
        // setSubmitButton(false)



    }






    const makeMessageHidden = (num) => {
        const timeout = setTimeout(() => {
            setAlertVisible(false)
        }, num)
        return () => clearTimeout(timeout)
    }

    const hideAlert = () => {
        setAlertVisible(false)
    }

    const handleSubmit = async() => {


        setOnClickSearch(true);
        setIsLoading(true);
        setSubmitButton(true)
         await authAxios.post(`/PDCReturn/requestList`, {
            requestorId: requestor,
            material: material,
            plant: "",
            fromDate: fromDate,
            toDate: toDate,
            status: status,
            processorId: processor,
            smUser: "vv2cif2",
            managerId: manager,
            flagFromPage: "searchlist"

        }, { headers }).then(
            res => {
                setResult(res.data);
                setIsLoading(false);
                if(res.data.length>0 && res.data[0].flag===true){
                    setAlertVariant('warning');
                    setMessage("More than 15000 data please try with shorter range of dates");
                    setAlertVisible(true)
                    makeMessageHidden(10000);
                    setIsLoading(false);
                    setResult(res.data);
                    getflagForCount(true);
                    
                    
                }else{
                getflagForCount(false)
                setResult(res.data);
                setIsLoading(false);}


            }
        ).catch(err => {
            setAlertVariant('warning');
            setMessage(ERROR_MESSAGE);
            setAlertVisible(true);
            setIsLoading(false)
            makeMessageHidden(5000);

        })
        setSubmitButton(false);
    }

    const columns = useMemo(
        () => [
            {
                Header: "Request Date",
                accessor: "requestDate",
            },
            {
                Header: "Requestor Name",
                accessor: "requestorName",
            },
            {
                Header: "Manager",
                accessor: "managerName",
            },
            {
                Header: "Material",
                accessor: "material",
            },
            {
                Header: "Quantity",
                accessor: "quantity",
            },
            {
                Header: "Urgency",
                accessor: "urgency",
            },
            {
                Header: "Destination",
                accessor: "destination",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Processor Name",
                accessor: "processorName",
            }

        ],
        []
    );




    return (


        <Fragment>

            {alertVisible ? <Alert id="snackbar" onClose={hideAlert} accessibilityLabel="Success:" variant={alertVariant} aria-atomic="true">
                <p className="uxf-alert-description">
                    {message}
                </p>
            </Alert> : null}
            <title>Search PDC Requests</title>
            <Card style={{ margin: '2%' }}>
                <Card.Body>
                    <Breadcrumb links={[{
                        title: "Home",
                        href: "/"
                    }, {
                        title: "Search List",

                    }]} label="breadcrumbs" />
                    <Form style={{ marginTop: '3%' }}>

                        <Form.Row>
                            <Col xs={12} md={4} style={{ marginRight: '2%' }}>
                                <Form.Label style={{ paddingRight: "1%", fontWeight: "bold" }}>
                                    Search By:
                                </Form.Label>

                                <Form.Control as="select" className="custom-select" onChange={handleSearchByChange}>
                                    <option>Search</option>
                                    <option value="dateRange">Date Range</option>
                                    <option value="Manager">Manager Id</option>
                                    <option value="Material">Material</option>
                                    <option value="Processor">Processor Id</option>
                                    <option value="Requestor">Requestor Id</option>
                                    <option value="Status">Status</option>
                                </Form.Control>
                            </Col>


                            {searchBy === "Material" ?

                                <><Col xs={12} md={6} style={{ marginRight: '1%' }}><Form.Label style={{ fontWeight: "bold" }}>Material:</Form.Label>
                                    <Form.Control type="text" value={material} placeholder="Enter Material" maxlength="12" style={{ textTransform: 'upperCase' }} required onChange={handlematerialChange} />


                                </Col> <Col><br /><Button variant="primary" disabled={material === ""||submitButton} onClick={handleSubmit}>Search</Button> </Col></>


                                :
                                searchBy === "dateRange" ?
                                    <><Col xs={12} md={3} style={{ marginRight: '1%' }}>
                                        <DatePicker name="fromdate" onInput={handlefromDateChange} placeholder={Moment(startdate1).format("DD-MM-YYYY")} labelText="FromDate" id="startdate" inputAriaLabel="date format: dd-mmm-yyyy" />
                                    </Col>
                                        <Col xs={12} md={3} style={{ marginRight: '1%' }}>

                                            <DatePicker name="todate" onInput={handletoDateChange} placeholder="ToDate" labelText="ToDate" id="enddate" inputAriaLabel="date format: yyyy-mm-dd" />

                                        </Col>
                                        <Col><br />
                                            <Button variant="primary" onClick={handleSubmit} disabled={submitButton}>Search</Button>
                                        </Col>
                                    </>
                                    : searchBy === "Requestor" ?
                                        <>
                                            <Col xs={12} md={6} style={{ marginRight: '1%' }}>
                                                <Form.Label style={{ fontWeight: "bold" }}>Requestor:</Form.Label>
                                                <Form.Control type="text" value={requestor} placeholder="Enter Requestor Id" maxlength="7" style={{ textTransform: 'upperCase' }} required onChange={handlerequestorChange} />

                                            </Col><Col><br /><Button variant="primary" disabled={requestor === "" || submitButton} onClick={handleSubmit}>Search</Button></Col> </>
                                        : searchBy === "Manager" ?
                                            <>
                                                <Col xs={12} md={6} style={{ marginRight: '1%' }}>
                                                    <Form.Label style={{ fontWeight: "bold" }}>Manager:</Form.Label>
                                                    <Form.Control type="text" value={manager} placeholder="Enter Manager Id" maxlength="15" style={{ textTransform: 'upperCase' }} required onChange={handlemanagerChange} />

                                                </Col><Col ><br /><Button variant="primary" disabled={manager === "" || submitButton} onClick={handleSubmit}>Search</Button> </Col></>
                                            : searchBy === "Processor" ?
                                                <><Col xs={12} md={6} style={{ marginRight: '1%' }}><Form.Label style={{ fontWeight: "bold" }}>Processor:</Form.Label>
                                                    <Form.Control type="text" value={processor} placeholder="Enter Processor Id" maxlength="7" style={{ textTransform: 'upperCase' }} required onChange={handleprocessorChange} />

                                                </Col><Col><br /><Button variant="primary" disabled={processor === "" || submitButton} onClick={handleSubmit}>Search</Button> </Col></>
                                                : searchBy === "Status" ?
                                                    <><Col xs={12} md={6} style={{ marginRight: '2%' }}>
                                                        <Form.Label style={{ fontWeight: "bold" }}>Status:</Form.Label>
                                                        <Form.Control as="select" className="custom-select" onClick={handlestatusChange}>
                                                            <option value="A">Approved</option>
                                                            <option value="C">Canceled</option>
                                                            <option value="D">Denied</option>
                                                            <option value="F">Finished</option>
                                                            <option value="I">In Process</option>                                                      
                                                            <option value="Z">Neither Finished Nor Canceled</option>
                                                            <option value="N">New</option>
                                                        </Form.Control>
                                                    </Col><Col><br /><Button variant="primary" disabled={submitButton} onClick={handleSubmit} >Search</Button> </Col></>
                                                    : <></>
                            }


                        </Form.Row>
                    </Form>

                    {/* {result.length !== 0 ? (isLoading ? (
                        <Loading />
                    ) : (
                        <TableContainerRequestView columns={columns} data={result} />
                    )) : (result.length === 0 && onClickSearch === true) ? (isLoading ? (
                        <Loading />
                    ) :
                        <h6 style={{ fontWeight: "bold" }}>No Data Found</h6>) : <></>} */}
                        {(isLoading?<Loading />:((result.length === 0 && onClickSearch === true)?<><br/><h6 style={{ fontWeight: "bold" }}>No Data Found</h6></>:(flagForCount===true?<><br/><h6 style={{ fontWeight: "bold" }}>Resultset is too large to display</h6></>:onClickSearch === true?<TableContainerRequestView columns={columns} data={result} />:null)))}
                </Card.Body>
            </Card>

        </Fragment>


    );
}